import "@hotwired/turbo"
import "./controllers/index_public"
import * as echarts from "echarts";
import "echarts/theme/dark.js";
window.echarts = echarts;
